import { getLayoutModules } from 'libs/layouts/getLayoutModules';
import type { LayoutConstructor } from '../../getAssetsToPreload';

type Module = Record<string, Record<string, unknown>>;
export type LayoutModule = Record<string, unknown>;

// Eagerly import all layout modules synchronously
// const modulesSync: Record<string, LayoutModule> = getLayoutModules();//import.meta.glob('/layouts/**/*.ts', { eager: true });
function getModules(): Record<string, LayoutModule> {
  return getLayoutModules();
}

const ensureTsExt = (p: string): string => (p.endsWith('.ts') ? p : `${p}.ts`);

export function normalizeLayoutPath(relativePath: string): string {
  const trimmed = relativePath.replace(/^\/layouts\//, '');
  return `/layouts/${ensureTsExt(trimmed)}`;
}

export function getAllLayoutModules(): Record<string, LayoutModule> {
  return getModules();
}

export type LayoutListEntry = { ctr: LayoutConstructor, name: string, path: string };

export function getAllLayoutConstructors(): LayoutListEntry[] {
  const out: LayoutListEntry[] = [];

  const modules = getAllLayoutModules();

  Object.keys(modules).forEach((path: string): void => {
    const match = path.match(/([^\\/]+)\.[^\\/]+$/);
    const layoutName = match ? match[1] : null;

    if (!layoutName) return;

    const module = modules[path] as Module;
    const layoutCtr = module[layoutName] as unknown as LayoutConstructor;

    if (!layoutCtr) return;

    out.push({ ctr: layoutCtr, name: layoutName, path });
  });

  return out;
}

export function getLayoutModuleByPath(relativePath: string): LayoutModule | undefined {
  const key = normalizeLayoutPath(relativePath);
  return getModules()[key];
}

export function getLayoutClassByPath<T>(relativePath: string): (new () => T) | null {
  const mod = getLayoutModuleByPath(relativePath);
  if (!mod) return null;
  const className = ensureTsExt(relativePath).split('/').pop()?.replace(/\.ts$/, '') ?? '';
  const ctor = mod[className] as new () => T;
  return typeof ctor === 'function' ? ctor : null;
}
